import React, { useEffect, useState } from 'react';
export function ReadingProgress() {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const updateProgress = () => {
      const scrollY = window.scrollY;
      const docHeight = document.documentElement.scrollHeight;
      const winHeight = window.innerHeight;
      const maxScroll = docHeight - winHeight;
      if (maxScroll > 0) {
        const pct = scrollY / maxScroll * 100;
        setProgress(Math.min(pct, 100));
      } else {
        setProgress(0);
      }
    };
    window.addEventListener('scroll', updateProgress);
    updateProgress(); // Initial call
    return () => window.removeEventListener('scroll', updateProgress);
  }, []);
  return <div className="fixed top-0 left-0 h-[3px] bg-amber z-[300] transition-[width] duration-100 ease-linear" style={{
    width: `${progress}%`
  }} data-id="element-82" />;
}